module.exports = "/_next/static/images/top-662768ba8bb7bb6d8cfa8025183dfe6e.jpg";